import { render, staticRenderFns } from "./WCG.vue?vue&type=template&id=9fbcbb2a&"
import script from "./WCG.vue?vue&type=script&lang=js&"
export * from "./WCG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports